import ElementContent from '@/components/sections/builder/elements/body/cart-item/content';
import ElementSetting from '@/components/sections/builder/elements/body/cart-item/setting';
import { ElementDataType } from '@/components/sections/builder/elements/body/cart-item/type';
import { BaggageClaim } from 'lucide-react';

const defaultData: ElementDataType = {
  name: 'Cart Item',
};

export const ElementPreviewIcon = BaggageClaim;

const CartItem = {
  type: 'cart_item',
  group: 'body_cart',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: ElementPreviewIcon,
  defaultChilds: [],
  childs: [],
  maxEntries: 1,
  isImmutable: true,
};

export default CartItem;
